import React from 'react';

// Abstract "Liquid Glass" placeholder for Space surfaces that have no real image
// (Space cards and the Space detail hero). Purely decorative and TEXT-FREE — the
// Space name already lives elsewhere in the UI. It reuses the canonical global
// background tokens (pages/_app.js): a light base with soft, blurred orange and
// blue/lilac blobs plus a very subtle top gradient. It fills its container
// (`absolute inset-0`) so the PARENT owns size, aspect ratio and rounding — it never
// alters existing layouts. No photo, no image asset.
export default function SpaceImageFallback({
  className = '',
}: {
  className?: string;
}) {
  return (
    <div
      aria-hidden="true"
      className={`absolute inset-0 overflow-hidden bg-white ${className}`}
    >
      {/* Orange blob (top-left) — a touch more present than the global glow so the
          cover reads as intentional, still soft. */}
      <div className="absolute -left-1/4 -top-1/3 h-[90%] w-[90%] rounded-full bg-tikipal-orange/25 blur-2xl" />
      {/* Blue/lilac blob (bottom-right). */}
      <div className="absolute -bottom-1/3 -right-1/4 h-[85%] w-[85%] rounded-full bg-indigo-300/30 blur-2xl" />
      {/* Very subtle top orange gradient, matching the global background wash. */}
      <div className="absolute inset-x-0 top-0 h-2/3 bg-gradient-to-b from-tikipal-orange/[0.08] to-transparent" />
    </div>
  );
}
